import http from '../../HttpConfig'
import {APIS_ENDPOINTS} from '../../SERVICE-CONSTANTS'

const Plans_endpoints = APIS_ENDPOINTS.plans

export interface IPlansMessagePayload {
  Id?: number
  Name: string
  Decription: string
  Price: string
  Discount: string
  DayOfPlan: string
  IconFile: File
}
export const request_create = async ({
  DayOfPlan,
  Decription,
  Discount,
  IconFile,
  Name,
  Price,
}: IPlansMessagePayload) => {
  const formData = new FormData()
  formData.append('DayOfPlan', DayOfPlan)
  formData.append('Decription', Decription)
  formData.append('Discount', Discount)
  formData.append('IconFile', IconFile)
  formData.append('Name', Name)
  formData.append('Price', Price)

  return http.post(Plans_endpoints.create, formData)
}
export const request_edit = async ({
  DayOfPlan,
  Decription,
  Discount,
  IconFile,
  Name,
  Price,
  Id,
}: IPlansMessagePayload) => {
  const formData = new FormData()
  formData.append('Id', Id?.toString() || '')
  formData.append('DayOfPlan', DayOfPlan)
  formData.append('Decription', Decription)
  formData.append('Discount', Discount)
  formData.append('IconFile', IconFile)
  formData.append('Name', Name)
  formData.append('Price', Price)

  return http.put(Plans_endpoints.create, formData)
}

export const request_getAll = async ({
  search,
  CurrentPage,
  PageSize,
}: {
  search?: string
  CurrentPage: number
  PageSize: number
}) => {
  return http.get(
    Plans_endpoints.getall +
      `?CurrentPage=${CurrentPage}&PageSize=${PageSize}${search ? `&search=${search}` : ''}`
  )
}

export const request_delete = async (id: number) => {
  return http.delete(Plans_endpoints.delete + `?id=${id}`)
}


export const request_unactive = async (id: number) => {
  return http.delete(Plans_endpoints.unactive + `?id=${id}`)
}

export const request_active = async (id: number) => {
  return http.delete(Plans_endpoints.active + `?id=${id}`)
}
